import { classNames } from '@/util/tailwindHelpers'
import SeriesBadge from '@/components/SeriesBadge'
import { useArcadeSeasonStarts } from '@/features/arcade/hooks/countdown'
import { MergedSeason } from '../types'

type Props = {
  season: MergedSeason
  className?: string
}

export default function SeasonStartCountdownBadge({
  season,
  className
}: Props) {
  const { seasonStarts } = useArcadeSeasonStarts({
    season,
    precision: 'medium'
  })

  const seasonSuffix = !seasonStarts?.remaining
    ? ''
    : `– ${seasonStarts?.formatted}`

  return (
    <SeriesBadge
      className={classNames(
        'w-max mx-auto bg-[--backgroundColor] transition-opacity duration-300',
        className
      )}
      size="xl"
      fluid
      label={`Season ${season?.id} ${seasonSuffix}`}
    />
  )
}
